import React, { useState, useEffect } from 'react';
import ButtonYellow from '../ButtonYellow/ButtonYellow';
import './FixedBar.css';

const FixedBar = ({
  parameters = {},
  membershiPriceDefault,
  scrollToCourseMembership = () => {},
  handleClickBtn = () => {},
  isMobile = false,
  isOnline = false
}) => {
  const [opacityArrowDowIndicator, setOpacityArrowDowIndicator] = useState(0);

  const handleScrollFiredArrowIndicator = {
    subscribe: ({ scrollStart = 0, scrollEnd = 0 }) => {
      const scrollY = window.scrollY;
      const scrollRange = scrollEnd - scrollStart;
      if (scrollY >= scrollStart && scrollY <= scrollEnd && scrollRange > 0) {
        setOpacityArrowDowIndicator(1);
      } else {
        setOpacityArrowDowIndicator(0);
      }
    },
    unsubscribe: () => setOpacityArrowDowIndicator(0)
  };

  const evaluateScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const scrollEnd = document.body.scrollHeight - 100; // 100px antes del final

    if (scrollPosition >= scrollEnd) {
      setOpacityArrowDowIndicator(0);
    } else {
      setOpacityArrowDowIndicator(1);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', evaluateScroll);
    return () => {
      document.removeEventListener('scroll', evaluateScroll);
    };
  }, []);

  if (isMobile) {
    return (
      <button
        style={{
          opacity: opacityArrowDowIndicator
        }}
        onClick={scrollToCourseMembership}
        className="btn yellow w-100 py-3"
        id="fixed-bar-course">
        {parameters?.STUDY_PLAN?.value}
      </button>
    );
  }

  return (
    <>
      {opacityArrowDowIndicator > 0 && membershiPriceDefault?.value && (
        <div
          className=" fixed-bar-container w-100 wrapper-portfolio bg-black"
          id="fixed-bar-course"
          style={{
            opacity: opacityArrowDowIndicator
          }}>
          <div className="container">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-column justify-content-start text-white w-100 mt-3">
                <span className="fs-md-5">
                  {parameters?.MEMBERSHIP_FAV?.value.replace(
                    '{membership_name}',
                    membershiPriceDefault?.role_name ?? 'Lite Thinking'
                  )}
                </span>
                <span className="bold fixed-bar-price">
                  {membershiPriceDefault?.value > 0
                    ? `${membershiPriceDefault?.symbol} ${Math.floor(
                        membershiPriceDefault?.value -
                          membershiPriceDefault?.value * membershiPriceDefault?.percentage
                      )} ${membershiPriceDefault?.main_currency}`
                    : 'US$'}
                </span>
                <span className="fs-5">
                  {membershiPriceDefault?.percentage > 0
                    ? `${Math.round(membershiPriceDefault?.percentage * 100)}% OFF`
                    : '30% OFF'}
                </span>
              </div>
              <div className="d-flex gap-3 justify-content-end align-items-center w-100 mt-3 ">
                {isOnline ? (
                  parameters?.GET_YOUR_CREDIT?.value?.toLowerCase() === 'true' && (
                    <ButtonYellow
                      ifispress={() => handleClickBtn(true)}
                      className="px-2 mx-0"
                      title={parameters?.SUCCES_CREDIT?.value ?? 'Logra tu crédito'}
                    />
                  )
                ) : (
                  <ButtonYellow
                    ifispress={() => handleClickBtn(true)}
                    className="px-2 mx-0"
                    title={parameters?.SUCCES_CREDIT?.value ?? 'Logra tu crédito'}
                  />
                )}
                <ButtonYellow
                  ifispress={scrollToCourseMembership}
                  className="px-2 mx-0"
                  title={parameters?.STUDY_PLAN?.value ?? 'Inscribirme ahora'}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FixedBar;
